export default __webpack_public_path__ + "static/media/event.a8d8ea82.svg";